/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class logmessage extends IceEntity {
    login_user_name: string = "";
    date: any = NaN;
    session_key: string = "";
    logtype: IceTypes.LOGTYPE = IceTypes.LOGTYPE.ltNone;
    account_type: number = 0;
    trans_account: string = "";
    message = "";

    constructor(cpy?: any) {
      super();
      if (cpy != null) {
        this.login_user_name = cpy.login_user_name;
        this.date = cpy.date;
        this.session_key = cpy.session_key;
        this.logtype = cpy.logtype;
        this.account_type = cpy.account_type;
        this.trans_account = cpy.trans_account;
        this.message = cpy.message;
      }
    }

    gettablename(): string {
        return "LOG_MESSAGE";
    }
}
